(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('sc3RenewRedirect', sc3RenewRedirect);

    sc3RenewRedirect.$inject = ['renewRedirect'];
    function sc3RenewRedirect(renewRedirect) {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, element, attrs) {
            element.on('click', click);

            function click(e) {
                var openInNewWindow = element.prop('target') === '_blank';
                e.preventDefault();
                renewRedirect(openInNewWindow);
            }
        }
    }
})();
